// Odpověď na komentář
// Přímo u konkrétního komentáře se naklonuje+upraví formulář na vytvoření příspěvku.

import { SVGLoader } from '@components';
import * as els from './forumElements';
import { forumTextarea } from './forumTextarea';
import { forumSendComment as sendComment } from './formSendComment';
import { forumTimer } from './forumTimer';
import { forumVerticalLine } from './forumVerticalLine';
import { updateButtonState } from './forumValidate';

//  TODO: unit testy https://cncenter.atlassian.net/browse/FEG-657
export const forumReplyToComment = (): void => {
  // Pro všechny tlačítka 'Odpovědět'
  els.buttonsResponse.forEach((buttonReply) => {
    // Po kliknutí
    buttonReply.addEventListener('click', () => {
      // Načíst pomocné elementy a ovládací prvky
      const parentComment = buttonReply.parentElement?.parentElement
        ?.parentElement as HTMLDivElement;
      const { commentUser: parentCommentUser, commentId: parentCommentId } = parentComment.dataset;
      const buttonCancel = parentComment.querySelector(
        '[data-button-reply-cancel]'
      ) as HTMLDivElement;

      // Skrýt button 'Odpovědět'
      buttonReply.classList.add(els.CLASS_ACTION_HIDDEN);

      // Zobrazit button 'Zrušit odpověď'
      buttonCancel.classList.remove(els.CLASS_ACTION_HIDDEN);

      // Připravit klon formuláře
      if (!els.formAddComment) return;

      const formReply = els.formAddComment.cloneNode(true) as HTMLDivElement;
      const formElement: HTMLElement | null = formReply.querySelector('form');

      if (!formElement) return;

      const threadId: HTMLInputElement | null = formElement.querySelector('[name="threadId"]');
      const textarea = formElement.querySelector('textarea') as HTMLTextAreaElement;
      const checkboxNotifyResponse: HTMLInputElement | null =
        formElement.querySelector('[name="notify"]');
      const labelNotifyResponse: HTMLLabelElement | null =
        formElement.querySelector('[for="chk_1"]');

      const notifyEmailRespond: HTMLInputElement | null =
        formElement.querySelector('[name="notify"]');
      const buttonAddComment = formElement.querySelector('[data-add-comment]') as HTMLInputElement;

      if (
        !notifyEmailRespond ||
        !threadId ||
        !textarea ||
        !buttonAddComment ||
        !checkboxNotifyResponse ||
        !labelNotifyResponse
      )
        return;

      // Nastavit unikátní identifikátor pro checkbox
      const checkBoxUniqueId = `notify-email-response-${Date.now()}`;
      checkboxNotifyResponse.setAttribute('id', checkBoxUniqueId);
      labelNotifyResponse.setAttribute('for', checkBoxUniqueId);

      // Vložit formulář před odpovědi
      const replies = parentComment.querySelector('.forum__comment-replies') as HTMLDivElement;
      replies.prepend(formReply);

      // Přidat @username do textarea
      textarea.value = `@${parentCommentUser as string} `;

      // Sledovat chybějící znaky & zapnutí autoheight
      forumTextarea(textarea);

      forumTimer();

      textarea.addEventListener('input', () => {
        updateButtonState({
          textarea,
          button: buttonAddComment,
          mentionUsername: parentCommentUser as string
        });
      });

      // Nastavit výchozí stav tlačítka
      updateButtonState({
        textarea,
        button: buttonAddComment,
        mentionUsername: parentCommentUser as string
      });

      // Odeslat odpověď
      buttonAddComment.addEventListener('click', (eventReply) => {

        // Přidat loader
        SVGLoader.create({ addTo: formElement });
        [
          textarea,
          textarea.nextElementSibling,
          buttonAddComment,
          notifyEmailRespond.parentElement,
        ].forEach((element) => {
          if (element instanceof HTMLElement) element.style.display = 'none';
        });

        // Odeslat data
        sendComment({
          threadId: threadId.value,
          content: textarea.value,
          parentCommentId,
          notifyEmailRespond: notifyEmailRespond.checked,
        });

        // Vyčistit formulář
        textarea.value = '';

        eventReply.preventDefault();
      });

      // Po kliknutí na 'Zrušit odpověď'
      const cancelReponseEvent = () => {
        // Odebrat formulář
        formReply.remove();

        // Skrýt button 'Zrušit odpověď'
        buttonCancel.classList.add(els.CLASS_ACTION_HIDDEN);

        // Zobrazit button 'Odpovědět'
        buttonReply.classList.remove(els.CLASS_ACTION_HIDDEN);
      };
      buttonCancel.removeEventListener('click', cancelReponseEvent);
      buttonCancel.addEventListener('click', cancelReponseEvent);

      forumVerticalLine();
    });
  });
};
